import { Link } from 'react-router-dom';
import { movies, latestMovies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function LatestUpdates() {
  const latest = latestMovies
    .map((id) => movies.find((m) => m.id === id))
    .filter(Boolean) as typeof movies;

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">实时同步，追剧不等待</p>
          </div>
          <Link
            to="/category/dianshiju"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5"
          data-product-shop
        >
          {latest.map((movie) => (
            <MovieCard key={movie.id} {...movie} />
          ))}
        </div>
      </div>
    </section>
  );
}